<template>
    <div class="signin-bg">
        <Header></Header>
        <div class="banner pr">
            <!--轮播图-->
            <div class="swiper-container swiper-container1">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item,index) in bannerList" :key="index">
                        <a :href="item.detail_url" target="_blank" title="">
                            <img :src="item.cover_url" />
                        </a>
                    </div>
                </div>
                <!-- Add Pagination -->
                <div class="swiper-pagination"></div>
            </div>
            <!--搜索区域-->
            <div v-show="showDialogSearch">
                <search-from :type-id=0></search-from>
            </div>
        </div>
        <!--图片区域-->
        <div class="img-all">
            <!--标题-->
            <p class="title">精选视频</p>
            <ul class="pubu">
                <li v-for="(item,index) in topicList" :key="index">
                    <a :href="item.detail_url">
                        <img :src="item.cover_url" alt=""/>
                    </a>
                    <p class="zhezhao"><span>{{item.name}}</span></p>
                </li>
            </ul>
        </div>
        <div class="hot-serch">
            <p class="title dbg">热门搜索</p>
            <div class="leixing">
                <ul>
                    <li v-for="(item,index) in hotSearchList" :key="index">
                        <a :href="item.detail_url">{{item.keyword}}</a>
                    </li>
                </ul>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from './Header';
    import SearchFrom from "./SearchFrom";
    import Footer from './Footer';
    import Swiper from 'swiper';
    import 'swiper/dist/css/swiper.min.css'
    import 'swiper/dist/js/swiper.min.js'

    export default {
        name: 'Video',
        components:{
            SearchFrom,
            Header,
            Footer
        },
        data() {
            return {
                bannerList:[],
                topicList:[],
                hotSearchList:[],
                showDialogSearch:false
            }
        },
        mounted() {
            this.getBannerList()
            this.getTopicList()
            this.getHotSearchList()
        },
        methods: {
            getBannerList(){
                this.$post('/dannertopic/getlist',{key: 'footage', type: '1'})
                    .then( res => {
                        if(res.code == 200){
                            this.bannerList = res.data.result
                            new Swiper('.swiper-container1', {
                                pagination: '.swiper-pagination',
                                paginationClickable: true,
                                nextButton: '.swiper-button-next',
                                prevButton: '.swiper-button-prev',
                                // slidesPerView: 1,
                                observerParents:true,
                                observer:true,
                                autoplay: 3000,
                                spaceBetween: 30,
                            });
                        }
                        this.showDialogSearch = true
                    }).catch(error => {
                    console.log(error.msg)
                })
            },
            getTopicList(){
                this.$post('/dannertopic/getlist',{key: 'footage', type: '2'})
                    .then( res => {
                        if(res.code == 200){
                            this.topicList = res.data.result
                        }
                    }).catch(error => {
                    console.log(error.msg)
                })
            },
            getHotSearchList(){
                this.$post('/dictionary/getlist',{key: 'footage'})
                    .then( res => {
                        if(res.code == 200){
                            this.hotSearchList = res.data.result
                        }
                    }).catch(error => {
                    console.log(error.msg)
                })
            }
        }
    }
</script>


<style scoped>
    * {  padding: 0; margin: 0; box-sizing: border-box; }
    a {text-decoration: none;color:#333;  }
    div, b, p, h1, h2, h3, h4, h5, h6,ul, li, dl, dd, header, footer {  margin: 0;  padding: 0;  list-style: none;  }
    em, i, b, strong {font-style: normal;font-weight: normal;}
    .ct{text-align: center;}
    .fl{float: left}
    .fr{float: right}
    .pr{position: relative}
    .pa{position: absolute}
    .hd{overflow: hidden;}
    img{vertical-align: top;}
    header .logo{margin-top: 16px;}
    header .nav,header .loging{display: flex;justify-content: space-between;}
    .nav li{margin: 0 20px;text-align: center;}
    .nav li.active::after{content:"";display:block;background: #FF9F00;height: 2px;width:80%;margin: -15px auto 0; }
    .nav li.active{font-weight: 600;}
    .loging .kefu img,.loging .tishi img{margin: 17px 20px 0;}
    .tishi{position: relative;}
    .tishi span.num{position: absolute;background: #E74C3A;border-radius:10px;color: #fff;min-width: 20px;height: 20px;font-size: 14px;text-align: center;line-height: 20px;display: inline-block;top:15px;right: 15px;padding: 0 4px;}
    .loging .user-down img{margin: 30px 10px 0}
    .user-down{cursor: pointer;position: relative;}

    .jiantou{ transform: rotate(180deg); -webkit-transform: rotate(180deg)}

    .swiper-slide a img{width:100%;height: auto; background-size:100%}
    .banner >>> .swiper-pagination-bullet{width: 35px;height: 3px;background:#000;border-radius: 1px;opacity: .3;}
    .banner >>> .swiper-pagination-bullet-active{background:#FF9F00;opacity: 1}
    .serch{background: #fff;height: 60px;display: flex;justify-content: space-between;position: absolute;bottom: 60px;z-index: 11111111;left: 50%;margin-left: -360px;}
    .xiala{font-size: 14px;}
    .dropdown{width: 110px;text-align: center;line-height: 60px;cursor: pointer;}
    .inpt{width: 510px;padding-left: 5px;position: relative;}
    input{border: none;height: 60px;line-height: 60px;width: 100%;padding-left:40px;outline:none;font-size: 16px;}
    input::-webkit-input-placeholder {color:#666; font-size: 14px; }
    input:-moz-placeholder {color:#666; font-size: 14px; }
    input::-moz-placeholder {color:#666;font-size: 14px;  }
    input:-ms-input-placeholder {color:#666; font-size: 14px; }
    .icon-scrch{width: 110px;background: #FF9F00;text-align: center;}
    .icon-scrch img{margin-top: 16px;cursor: pointer;}

    .xiala img{margin-top: 24px;}
    .inpt img{margin-top: 18px;position: absolute;}
    .dropdown {position: relative;}
    .dropdown_menu {background: #fff;position: absolute;top: 60px;right: 0px;z-index: 1000;display: none;width: 110px;padding:10px 0;text-align: center;border-top: 1px solid #ddd;}
    .dropdown_menu dd{line-height: 34px!important;}
    .dropdown dl dd a {color: #333;line-height: 34px;font-size:14px;}
    .top-arrow1,.top-arrow2 {width:0;height:0;display:block;position:absolute;left:30px;top:-17px;z-index:5; /*����ie8-*/ border-top:8px transparent dashed;border-left:6px transparent dashed;border-right:6px transparent dashed;border-bottom:8px white solid;overflow:hidden;}
    .top-arrow1 {border-bottom:9px #ddd solid;}
    .top-arrow2 {top:-15px;border-bottom:9px #fff solid;}

    .img-all{padding: 50px 0;}
    .title{margin: 0 auto 50px;font-size: 26px;font-weight: 600;text-align: center;}
    .pubu{width: 1200px;margin: 0 auto;overflow: hidden;}
    .pubu li{border-radius: 10px;overflow: hidden;position: relative;float:left;margin:5px;cursor: pointer;}
    .pubu li:hover .zhezhao{display: none;}
    .pubu li .zhezhao{background: rgba(0,0,0,.2);position: absolute;top:0;right: 0;width: 100%;height: 100%;text-align: center;color: #fff;font-size: 22px;font-weight: 600;}
    .pubu li .zhezhao span{position: relative;top:50%;display: block;height: 30px;line-height: 30px;margin-top: -15px;}
    .img-all .pubu img{max-width: 290px;}

    .hot-serch{padding: 50px 0;background: #F7F7F7;}
    .dbg{background: url("../assets/search/bg.png")no-repeat center;height: 41px;line-height: 41px;width: 167px;}
    .leixing{width: 1200px;margin: 0 auto;}
    .leixing ul{display: flex;justify-content: space-around;flex-wrap: wrap;}
    .leixing ul li{margin: 10px;}
    .leixing ul li a{display:inline-block;width: 130px;height: 40px;line-height: 40px;background: #fff;text-align: center;font-size: 14px;border-radius: 5px;}

    footer{height: 180px;background: #fff;padding: 70px 0 0;}
    footer p{font-size: 12px;color: #999;text-align: center;}
</style>
